module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_item_message":"登録されたビデオがありません。"}}')
  delete Component.options._Ctor
}
